export const altenarScript = (libraryUrl: string) => `
!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    t.onload = execCactusEvents('altenar');
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  '${libraryUrl}',
  "altenar-script"
  );
`;
